<template>
  <TabMenu
    :model="items"
    :active-index="currentTabIndex"
    @tab-change="tabChange"
  >
    <template #item="{ label, item, props }">
      <router-link
        v-if="item.route && !item.disabled"
        v-slot="routerProps"
        :to="item.route"
        custom
      >
        <a
          :href="item.route.path"
          v-bind="props.action"
          @click="routerProps.navigate"
        >
          <TIcon v-if="item.icon" :icon="item.icon" class="mr-2" />
          <span v-bind="props.label">{{ label }}</span>
          <TBadge
            v-if="item.badge"
            class="ml-1"
            name="tab-menu-badge"
            :value="item.badge"
          />
        </a>
      </router-link>
      <div
        v-else
        v-tooltip.bottom="item.disabledTooltip"
        v-bind="props.action"
        :class="{ 'tab-disabled': item.disabled }"
      >
        <TIcon v-if="item.icon" :icon="item.icon" class="mr-2" />
        <span v-bind="props.label">{{ label }}</span>
        <TBadge
          v-if="item.badge"
          class="ml-1"
          name="tab-menu-badge"
          :value="item.badge"
        />
      </div>
    </template>
  </TabMenu>
</template>

<script lang="ts">
import TBadge from '@thyme/nashville/src/components/badge/TBadge.vue'
import TIcon from '@thyme/nashville/src/components/icon/TIcon.vue'
import { MenuItem } from '@thyme/nashville/src/types/navbar'
import TabMenu, { TabMenuChangeEvent } from 'primevue/tabmenu'
import { PropType, defineComponent } from 'vue'

export default defineComponent({
  components: {
    TBadge,
    TIcon,
    TabMenu,
  },
  props: {
    items: {
      type: Array as PropType<MenuItem[]>,
      required: true,
    },
    currentTabIndex: {
      type: Number,
      required: true,
    },
  },
  emits: ['tabChange'],
  setup(props, context) {
    /**
     *
     * @param tab
     */
    function tabChange(tab: TabMenuChangeEvent) {
      context.emit('tabChange', tab)
    }
    return {
      tabChange,
    }
  },
})
</script>
<style lang="scss" scoped>
.tab-disabled {
  pointer-events: auto;
  opacity: 0.5;
  align-items: center;
  display: flex;
}
</style>
